module.exports = __webpack_public_path__ + "static/media/arrow-svgrepo-com.3fd7fe67.svg";